import { Link } from "react-router-dom";
import Logo from "../components/Logo";
import "../css/LandingPage.css";

export default function NotFoundPage() {
  return (
    <main className="standalone-login">
      <section className="standalone-login-panel status-page" aria-labelledby="not-found-title">
        <Logo maxWidth="220px" marginBottom="1rem" />
        <p className="status-code">404</p>
        <h1 id="not-found-title">Page not found</h1>
        <p>The page you are looking for does not exist or may have moved.</p>
        <Link className="primary-action" to="/">
          Return home
        </Link>
      </section>
    </main>
  );
}
